import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';

const ExportAll = (props) => {
  const { taxData,startDate,endDate,year } = props;

  const exportMapping = [
    {
      header: 'Payout Date',
      value: (row) => row.payoutDate ? `="${row.payoutDate}"` : ''
    },
    {
      header: 'Invoice No',
      value: (row) => `${row.invoiceNo}`
    },
    {
      header: 'Invoice Type',
      value: (row) => `${row.invoiceType}`
    },
    {
      header: 'Expert Name',
      value: (row) => `${row.expertName}`
    },
    {
      header: 'GSTIN (if any)',
      value: (row) => `${row.gstin || ''}`
    },
    {
      header: 'Place of Supply',
      value: (row) => `${row.placeOfSupply || ''}`
    },
    {
      header: 'Taxable Value',
      value: (row) => `${row.taxableValue}`
    },
    {
      header: 'GST Rate',
      value: (row) => `${row.gstRate}`
    },
    {
      header: 'CGST',
      value: (row) => `${row.cgst}`
    },
    {
      header: 'SGST',
      value: (row) => `${row.sgst}`
    },
    {
      header: 'IGST',
      value: (row) => `${row.igst}`
    },
    {
      header: 'Total Invoice Value',
      value: (row) => `${row.totalInvoiceValue}`
    },
    {
      header: 'Service Type',
      value: (row) => `${row.serviceType || ''}`
    },
    {
      header: 'Payment Mode',
      value: (row) => `${row.paymentMode || ''}`
    },
    {
      header: 'Remarks',
      value: (row) => `${row.Remarks || ''}`
    }
  ];

  const handleExportAllRows = async () => {
    try {

      // Transform data using custom mapping
      const exportData = taxData.map(row => {
        return exportMapping.reduce((acc, field) => {
          acc[field.header] = field.value(row);
          return acc;
        }, {});
      });

      // Create CSV content
      const headers = exportMapping.map(field => `"${field.header}"`).join(',');
      const csvContent = exportData.map(row => 
        exportMapping.map(field => 
          `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
        ).join(',')
      );

      csvContent.unshift(headers);

      // Create and download file
      const csvString = csvContent.join('\n');
      const blob = new Blob(['﻿', csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const fileName = `Expert_Platform_GST_Details_${dayjs(startDate).format('DD-MM-YYYY')}_to_${dayjs(endDate).format('DD-MM-YYYY')}`;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Export Successful',
        html: `
          <p>If download doesn't start automatically, click on provided link:
          <a href="${url}" download="${fileName}.csv" style="color: blue; text-decoration: underline;">
            Download CSV
          </a></p>
        `,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });

    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };

  return (
    <Box>        
      <Button 
        onClick={handleExportAllRows}
        startIcon={<SaveAlt />}
        sx={{textTransform:'none'}}
      >
        Export
      </Button>      
    </Box>
  );
}

export default ExportAll;